(() => {
  const STYLE_ID = 'sm-audio-loading-ui';
  const SHOW_DELAY = 500;

  const copy = zh => zh ? {
    loading: '正在载入音频…',
    loadingPct: p => `正在载入音频… 已缓冲 ${p}%`,
    buffering: '正在缓冲…',
    bufferingPct: p => `正在缓冲… 已缓冲 ${p}%`,
    slow: '网络较慢，仍在加载，请稍候…',
    slowPct: p => `网络较慢，仍在加载… 已缓冲 ${p}%`,
    error: '音频加载失败，请重试，或点击“打开音频”。'
  } : {
    loading: 'Loading audio…',
    loadingPct: p => `Loading audio… ${p}% buffered`,
    buffering: 'Buffering…',
    bufferingPct: p => `Buffering… ${p}% buffered`,
    slow: 'Network is slow — still loading…',
    slowPct: p => `Network is slow — ${p}% buffered`,
    error: 'Audio couldn’t load. Try again or use “Open audio”.'
  };

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      /* Requested copy is removed from the live DOM; keep it hidden before deferred JS removes it. */
      .smtool-hero>p,.smbps-fixed-output,.smbps-engineering-note{display:none!important}
      .smtool-loadstate[hidden]{display:none!important}
      .smtool-loadstate{grid-column:1/-1;display:grid;gap:5px;min-width:0;padding:0 2px 1px}
      .smtool-loadline{display:flex;align-items:center;gap:7px;min-width:0;color:#d7c7df;font-size:10px;line-height:1.25}
      .smtool-loadline>span[data-sm-loadtext]{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
      .smtool-loadline strong{margin-left:auto;flex:0 0 auto;color:#fff;font-size:9px;font-weight:800;font-variant-numeric:tabular-nums}
      .smtool-loadspinner{width:12px;height:12px;flex:0 0 auto;border:2px solid rgba(255,255,255,.22);border-top-color:#fff;border-radius:50%;animation:smtool-load-spin .7s linear infinite}
      .smtool-loadrail{height:3px;overflow:hidden;border-radius:999px;background:#4b3a54}
      .smtool-loadrail i{display:block;width:var(--sm-load-pct,0%);height:100%;border-radius:inherit;background:linear-gradient(90deg,#dcbaf2,var(--sm-accent,#8c3ec5));transition:width .18s ease}
      .smtool-loadstate.is-indeterminate .smtool-loadrail i{width:28%;animation:smtool-load-scan 1s ease-in-out infinite}
      .smtool-loadstate.is-slow .smtool-loadline{color:#f0d9ff}
      .smtool-loadstate.is-error .smtool-loadline{color:#ffd8df}
      .smtool-loadstate.is-error .smtool-loadspinner{display:none}
      .smtool-loadstate.is-error .smtool-loadrail i{width:100%;background:#a94b62;animation:none}
      .smtool-track.is-audio-loading .smtool-track-play{font-size:0}
      .smtool-track.is-audio-loading .smtool-track-play::after{content:"";width:14px;height:14px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:smtool-load-spin .7s linear infinite}
      @keyframes smtool-load-spin{to{transform:rotate(360deg)}}
      @keyframes smtool-load-scan{0%{transform:translateX(-150%)}100%{transform:translateX(390%)}}
      @media(max-width:600px){.smtool-loadstate{padding-top:1px}.smtool-loadline{font-size:9px}}
      @media(prefers-reduced-motion:reduce){.smtool-loadspinner,.smtool-track.is-audio-loading .smtool-track-play::after{animation-duration:1.5s}.smtool-loadstate.is-indeterminate .smtool-loadrail i{animation:none;width:45%}}
    `;
    document.head.appendChild(style);
  }

  function removeRequestedCopy(root) {
    const subtitle = root.querySelector('.smtool-hero > p');
    if (subtitle) subtitle.remove();
    root.querySelectorAll('.smbps-fixed-output,.smbps-engineering-note').forEach(node => node.remove());
  }

  function init(root) {
    if (!root || root.dataset.smLoadUiReady === '2') return;
    removeRequestedCopy(root);

    const audio = root.querySelector('[data-sm-audio]');
    const player = root.querySelector('[data-sm-player]');
    const inner = player && player.querySelector('.smtool-player-inner');
    if (!audio || !inner) return;

    root.dataset.smLoadUiReady = '2';
    audio.preload = 'auto';

    const zh = root.dataset.smLang === 'zh';
    const L = copy(zh);
    const state = document.createElement('div');
    state.className = 'smtool-loadstate is-indeterminate';
    state.dataset.smLoadstate = '';
    state.hidden = true;
    state.setAttribute('aria-live', 'polite');
    state.innerHTML = '<div class="smtool-loadline"><span class="smtool-loadspinner" aria-hidden="true"></span><span data-sm-loadtext></span><strong data-sm-loadpct></strong></div><div class="smtool-loadrail" aria-hidden="true"><i data-sm-loadfill></i></div>';
    inner.insertBefore(state, audio);

    const text = state.querySelector('[data-sm-loadtext]');
    const pct = state.querySelector('[data-sm-loadpct]');
    let showTimer = 0;
    let slowTimer = 0;
    let loading = false;
    let uiVisible = false;
    let mode = 'loading';
    let failed = false;
    let pendingRow = null;

    function bufferedPercent() {
      if (!Number.isFinite(audio.duration) || audio.duration <= 0 || !audio.buffered || !audio.buffered.length) return null;
      try {
        const end = audio.buffered.end(audio.buffered.length - 1);
        return Math.max(0, Math.min(100, Math.round(end / audio.duration * 100)));
      } catch (_) {
        return null;
      }
    }

    function clearRowSpinner() {
      root.querySelectorAll('.smtool-track.is-audio-loading').forEach(row => row.classList.remove('is-audio-loading'));
    }

    function syncRowSpinner() {
      if (!loading || failed || !uiVisible) return;
      clearRowSpinner();
      const row = pendingRow && pendingRow.isConnected ? pendingRow : root.querySelector('.smtool-track.is-current');
      if (row) row.classList.add('is-audio-loading');
    }

    function renderState(nextMode = mode, force = false) {
      mode = nextMode;
      if (!uiVisible && !force) return;
      const p = bufferedPercent();
      state.hidden = false;
      state.classList.toggle('is-indeterminate', p == null);
      state.classList.toggle('is-slow', mode === 'slow');
      state.classList.toggle('is-error', mode === 'error');
      state.style.setProperty('--sm-load-pct', `${p == null ? 0 : p}%`);
      pct.textContent = p == null || mode === 'error' ? '' : `${p}%`;

      if (mode === 'error') text.textContent = L.error;
      else if (mode === 'slow') text.textContent = p == null ? L.slow : L.slowPct(p);
      else if (mode === 'buffering') text.textContent = p == null ? L.buffering : L.bufferingPct(p);
      else text.textContent = p == null ? L.loading : L.loadingPct(p);
    }

    function finishLoading() {
      loading = false;
      failed = false;
      uiVisible = false;
      clearTimeout(showTimer);
      clearTimeout(slowTimer);
      showTimer = 0;
      slowTimer = 0;
      pendingRow = null;
      clearRowSpinner();
      state.hidden = true;
      state.classList.remove('is-slow', 'is-error', 'is-indeterminate');
    }

    function scheduleVisible() {
      if (showTimer) return;
      showTimer = window.setTimeout(() => {
        showTimer = 0;
        if (!loading || failed) return;
        if (!audio.paused && !audio.ended && audio.readyState >= 3) {
          finishLoading();
          return;
        }
        uiVisible = true;
        renderState(mode, true);
        syncRowSpinner();
      }, SHOW_DELAY);
    }

    function armSlowTimer() {
      if (slowTimer) return;
      slowTimer = window.setTimeout(() => {
        slowTimer = 0;
        if (!loading || failed) return;
        if (!audio.paused && !audio.ended && audio.readyState >= 3) {
          finishLoading();
          return;
        }
        mode = 'slow';
        if (uiVisible) renderState('slow', true);
      }, 3500);
    }

    function startLoading(nextMode = 'loading', row = null) {
      failed = false;
      mode = nextMode;
      if (row) pendingRow = row;

      if (loading) {
        if (uiVisible) {
          renderState(mode, true);
          syncRowSpinner();
        }
        return;
      }

      loading = true;
      uiVisible = false;
      state.hidden = true;
      clearRowSpinner();
      scheduleVisible();
      armSlowTimer();
    }

    function showError() {
      loading = false;
      failed = true;
      uiVisible = true;
      clearTimeout(showTimer);
      clearTimeout(slowTimer);
      showTimer = 0;
      slowTimer = 0;
      clearRowSpinner();
      renderState('error', true);
    }

    root.addEventListener('click', event => {
      const target = event.target.closest('.smtool-track-play,[data-sm-play-recommended],[data-sm-prev],[data-sm-next],[data-sm-mainplay]');
      if (!target || !root.contains(target)) return;

      if (target.matches('.smtool-track-play')) {
        const row = target.closest('.smtool-track');
        const isCurrent = !!(row && row.classList.contains('is-current'));
        if (isCurrent && !audio.paused) return;
        if (isCurrent && audio.paused && audio.readyState >= 3 && !failed) return;
        if (isCurrent && failed) { try { audio.load(); } catch (_) {} }
        startLoading('loading', row);
        return;
      }

      if (target.matches('[data-sm-mainplay]')) {
        if (!audio.paused) return;
        if (audio.readyState >= 3 && !failed) return;
        if (failed) { try { audio.load(); } catch (_) {} }
      }
      startLoading('loading');
    }, true);

    audio.addEventListener('loadstart', () => {
      if (audio.currentSrc || audio.src) startLoading('loading');
    });
    audio.addEventListener('loadedmetadata', () => { if (loading && uiVisible) renderState(mode, true); });
    audio.addEventListener('progress', () => { if (loading && uiVisible) renderState(mode, true); });
    audio.addEventListener('waiting', () => {
      if (!audio.ended) startLoading('buffering');
    });
    audio.addEventListener('stalled', () => {
      if (!audio.ended) startLoading('buffering');
    });
    audio.addEventListener('playing', finishLoading);
    audio.addEventListener('error', showError);
    audio.addEventListener('ended', finishLoading);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden && audio.paused) finishLoading();
    });
  }

  injectStyles();
  const initAll = (scope = document) => scope.querySelectorAll('[data-square-music-tool]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
